var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoteExpertFeedbacksArrowleftMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 34,
    viewBox: "0 0 10 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.70643 33.0563C8.8939 32.6656 8.99922 32.1358 8.99922 31.5834C8.99922 31.0309 8.8939 30.5011 8.70643 30.1105L2.41343 17L8.70643 3.88962C8.80194 3.69744 8.87812 3.46756 8.93053 3.21338C8.98294 2.95921 9.01053 2.68583 9.01168 2.40921C9.01283 2.13258 8.98753 1.85826 8.93725 1.60222C8.88697 1.34619 8.81272 1.11358 8.71883 0.917969C8.62493 0.722359 8.51328 0.567661 8.39038 0.46291C8.26749 0.358158 8.13581 0.305447 8.00303 0.30785C7.87025 0.310253 7.73903 0.367725 7.61703 0.476913C7.49502 0.586098 7.38468 0.744808 7.29243 0.943787L0.29243 15.5271C0.104959 15.9178 -0.000355721 16.4476 -0.000355721 17C-0.000355721 17.5525 0.104959 18.0823 0.29243 18.473L7.29243 33.0563C7.47996 33.4469 7.73427 33.6663 7.99943 33.6663C8.26459 33.6663 8.5189 33.4469 8.70643 33.0563Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteExpertFeedbacksArrowleftMobile);
export default __webpack_public_path__ + "static/media/note-expert-feedbacks-arrowleft-mobile.708b1f8de3d8027a0cadb5d7185add36.svg";
export { ForwardRef as ReactComponent };